import React from "react";
import { PersonBlock } from "@/pages/ContactsPage/Components/PersonBlock";
import { ConnectionsTable } from "@/features/ConnectionsTable";
import { ContactsTabs } from "@/pages/ContactsPage/Components/ContactsTabs";
import styles from "./styles.module.scss";

interface Props {}

export const ConnectionsTabMobile: React.FC<Props> = () => {
  return (
    <div className={styles.container}>
      <PersonBlock />
      <ContactsTabs />
      <ConnectionsTable />
    </div>
  );
};
